import { create } from "zustand";

interface DriveState {
  selectedDriveId: string | null;
  setSelectedDriveId: (driveId: string | null) => void;
}

const useDriveStore = create<DriveState>((set) => ({
  selectedDriveId: null,
  setSelectedDriveId: (driveId) => set({ selectedDriveId: driveId }),
}));

export default useDriveStore;
